import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { fetchText, publishText, getTextBackups } from '../services/api'
import type { SiteText } from '../types'

export function useText(locale: string = 'en') {
  return useQuery({
    queryKey: ['admin-text', locale],
    queryFn: () => fetchText(locale),
    staleTime: 0,
    refetchOnWindowFocus: false,
  })
}

export function usePublishText() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      data,
      etag,
      locale = 'en',
    }: {
      data: SiteText
      etag: string
      locale?: string
    }) => publishText(data, etag, locale),
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin-text', variables.locale || 'en'] })
    },
  })
}

export function useTextBackups(locale: string = 'en') {
  return useQuery({
    queryKey: ['admin-text-backups', locale],
    queryFn: () => getTextBackups(locale),
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  })
}
